import { BaseElectionPost } from "./base/BaseElectionPost";
import { buildElectionUrl, convertirFecha, formatProvinciaLocalidad } from "../utils/dataFormatter";

export class DiputadosPost extends BaseElectionPost {
  constructor() {
    super({
      electionType: 'diputados',
      thresholds: { low: 0, medium: 10, high: 10 }
    });
  }

  /**
   * TEMPLATE 1: Sin datos (pre-resultados)
   */
  createInitialContent(data, params) {
    const provincia = data.provincia || 'Argentina';
    const localidad = data.localidad || provincia;

    return {
      title: `Resultados Elecciones 2025 en ${localidad}: a qué hora se conocerán los primeros datos oficiales`,
      summary: `
        <ul>
          <li>Los ciudadanos de ${localidad} eligen legisladores este domingo 26 de octubre.</li>
          <li>El escrutinio minuto a minuto, el mapa de resultados y todo lo que tenés que saber de las legislativas.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2025-10-26T14:00:00-03:00",
      formattedPublishedDate: "26 OCT 2025",
      lastModified: new Date().toISOString(),
      gtmPublishedDate: "2025-10-26T",
      modificatedAt: new Date().toISOString(),
      body: [
        {
          type: "text",
          value: `<p>Los ciudadanos de <strong>${localidad}</strong> acudieron a las urnas este domingo 26 de octubre para participar en las <strong>elecciones legislativas 2025</strong>, a partir de las cuales se renovará una parte clave del poder legislativo: la Cámara de Diputados y el Senado de la Nación.</p>`
        },
        {
          type: "text",
          value: `<p>Hay gran expectativa por los <strong>resultados oficiales</strong> en ${localidad} y en el país en general, los cuales comenzarán a difundirse cerca de las 21 horas.</p>`
        },
        {
          type: "text",
          value: `<p>A nivel general, más de 35 millones de personas figuran en el padrón electoral. La obligación de votar alcanza a todos los ciudadanos argentinos, naturalizados y a los extranjeros con residencia permanente, entre los 18 y 70 años. Para los que tienen de 16 a 18 años, así como para los mayores de 70, el voto es opcional.</p>`
        },
        {
          type: "text",
          value: `<p>Seguí toda la información del escrutinio de las Elecciones legislativas 2025 y todo lo que tenés que saber, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/elecciones-2025-asumen-nuevos-diputados-senadores_0_efms57JpK0.html" target="_blank" rel="noopener noreferrer">Cuándo asumen los nuevos diputados y senadores</a></h2>`
        },
        {
          type: "text",
          value: `<p>Los legisladores electos asumirán sus funciones el 10 de diciembre. De acuerdo con el cronograma electoral, la fecha es la misma tanto para los cargos nacionales como para los cargos locales.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/elecciones-2025-vota-domingo-26-octubre_0_LJ8ckau2n1.html" target="_blank" rel="noopener noreferrer">Qué se vota en las Elecciones nacionales 2025</a></h2>`
        },
        {
          type: "text",
          value: `<p>En esta elección se renueva la mitad de la Cámara de Diputados, es decir 127 bancas, distribuidas entre todas las provincias en proporción a su población. También se elige un tercio del Senado (24 bancas), que este año corresponde a la Ciudad Autónoma de Buenos Aires, Chaco, Entre Ríos, Neuquén, Río Negro, Salta, Santiago del Estero y Tierra del Fuego.</p>`
        },
        {
          type: "text",
          value: `<p>Cabe destacar que a través del Decreto 171/2025, se promulgó la Ley 27.783, por la cual se suspendieron las elecciones PASO durante 2025.</p>`
        },
        {
          type: "text",
          value: `<p>Además, es la primera elección legislativa nacional con Boleta Única de Papel (BUP) como formato de votación.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/pasa-voto-elecciones-2025-multas-justificacion-documentos_0_drGEE6u5b8.html" target="_blank" rel="noopener noreferrer">Qué pasa si no voto en estas elecciones en ${localidad}</a></h2>`
        },
        {
          type: "text",
          value: `<p>En estas elecciones legislativas del 26 de octubre, el voto es obligatorio para todos los ciudadanos argentinos de entre 18 y 70 años. Tanto para los habitantes de ${localidad} como del resto del país, no presentarse sin justificación puede traer multas económicas y restricciones administrativas.</p>`
        },
        {
          type: "text",
          value: `<p>Quienes no concurran deberán presentar una justificación válida dentro de los 60 días posteriores al comicio. Además, deberán afrontar una multa cuyo valor varía entre $1.000 y $2.000, dependiendo de la cantidad de veces que se haya omitido votar en elecciones anteriores.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/pasa-voto-elecciones-2025-multas-justificacion-documentos_0_drGEE6u5b8.html" target="_blank" rel="noopener noreferrer">Elecciones legislativas 2025: cómo justificar el no voto en ${localidad}</a></h2>`
        },
        {
          type: "text",
          value: `<p>Quienes no votaron y tienen una excepción legal pueden justificar el no voto online. El trámite se hace en la web de la Cámara Nacional Electoral y permite evitar multas y sanciones.</p>`
        },
        {
          type: "text",
          value: `<p>Para comenzar, hay que escribir el número de DNI, género, distrito de votación y código de validación. El sistema indica automáticamente si el votante figura como infractor y da la opción de justificar o pagar la multa.</p>`
        },
        {
          type: "text",
          value: `<p>En caso de justificar, se debe adjuntar un documento que acredite el motivo: certificado médico, constancia policial, pasajes de viaje o cualquier comprobante que respalde la inasistencia. La documentación será evaluada por la Secretaría Electoral correspondiente.</p>`
        },
        {
          type: "text",
          value: `<p>Si la justificación es aceptada, el votante es dado de baja del Registro de Infractores. Si es rechazada, se deberá abonar la multa establecida por el Código Electoral, que va de los $1000 a los $2000, según la cantidad de multas acumuladas.</p>`
        },
        {
          type: "text",
          value: `<h2>Boca de urna en ${localidad}: qué es y cómo funciona</h2>`
        },
        {
          type: "text",
          value: `<p>"Boca de urna" es uno de los términos más buscados tanto en redes sociales como en Google a la hora de anticiparse a los resultados oficiales de cada elección. Se trata de encuestas que se realizan a la salida de los establecimientos electorales luego de que los votantes emitieron su sufragio.</p>`
        },
        {
          type: "text",
          value: `<p>Los medios de comunicación no pueden publicar estas cifras por ley, pues está prohibido cualquier tipo de difusión masiva de datos extraoficiales.</p>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * TEMPLATE 2: Con resultados
   */
  createEarlyContent(data, params) {
    return this.createResultsContent(data, params);
  }

  createPartialContent(data, params) {
    return this.createResultsContent(data, params);
  }

  createFinalContent(data, params) {
    return this.createResultsContent(data, params);
  }

  createResultsContent(data, params) {
    const provincia = data.provincia || 'Argentina';
    const localidad = data.localidad || provincia;
    const mesas = data.mesasEscrutadas?.toFixed(2) || '0.00';
    let blocksData = params?.blocksNational?.blocks || [];

    // Primeros 3 lugares
    const primero = data.ganador || data.candidatos?.[0] || data.blocks?.[0];
    const segundo = data.segundo || data.candidatos?.[1] || data.blocks?.[1];
    const tercero = data.tercero || data.candidatos?.[2] || data.blocks?.[2];

    // Lista completa de resultados
    const resultadosLista = data.candidatos?.map(c => {
      const nombre = c.name || c.candidates?.[0]?.fullname || 'Sin nombre';
      const porcentaje = c.votes_percent?.toFixed(2) || '0.00';
      return `<li><strong>${nombre}</strong> (${porcentaje}%)</li>`;
    }).join('\n') || '';
    
    return {
      title: `Resultados en ${localidad} para Diputados: quién ganó las Elecciones 2025`,
      summary: `
        <ul>
          <li>Los ciudadanos de ${localidad} eligieron a los nuevos representantes para el Congreso este domingo 26 de octubre.</li>
          <li>El escrutinio minuto a minuto, el mapa de resultados y todo lo que tenés que saber de las legislativas.</li>
        </ul>`,
      subtitle: "",
      description: "",
      publishedDate: "2025-10-26T14:00:00-03:00",
      formattedPublishedDate: "26 OCT 2025",
      lastModified: data.last_update,
      gtmPublishedDate: "2025-10-26T",
      modificatedAt: data.last_update,
      keywords: "resultados, diputados, senadores, quién ganó, lugar",
      body: [
        {
          type: "text",
          value: `<p>Los ciudadanos de <strong>${localidad}</strong> acudieron a las urnas este domingo 26 de octubre para participar en las <strong>elecciones legislativas 2025</strong>, a partir de las cuales se renovará una parte clave del poder legislativo: la Cámara de Diputados y el Senado de la Nación.</p>`
        },
        {
          type: "text",
          value: `<p>Con respecto a la Cámara Baja, en <strong>${localidad}</strong> se ubica en primer lugar <strong>${primero?.name || primero?.candidates?.[0]?.fullname}</strong>, con el <strong>${primero?.votes_percent?.toFixed(2)}%</strong> de los sufragios, en tanto que en segunda posición se encuentra <strong>${segundo?.name || segundo?.candidates?.[0]?.fullname}</strong>, con el <strong>${segundo?.votes_percent?.toFixed(2)}%</strong>, y le sigue <strong>${tercero?.name || tercero?.candidates?.[0]?.fullname}</strong>, con el <strong>${tercero?.votes_percent?.toFixed(2)}%</strong>. A continuación, todos los resultados, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<h2>Elecciones 2025 en ${localidad}: resultados en Diputados</h2>`
        },
        {
          type: "text",
          value: `<p>Con el <strong>${mesas}%</strong> de las mesas escrutadas, estos son los resultados en ${localidad}:</p>`
        },
        {
          type: "text",
          value: `<ul>${resultadosLista}</ul>`
        },
        {
          type: "text",
          value: `<h2>Resultados de las Elecciones 2025 en Diputados en todo el país</h2>`
        },
        {
          type: "text",
          value: (() => {
            if (blocksData && blocksData.length > 0) {
              const blocksList = data?.blocks
                .map((block, index) => {
                  const nombre = block.name || "Sin nombre";
                  const porcentaje = block.votes_percent?.toFixed(2) || "0.00";

                  if (index === 0) {
                    return `<strong>${nombre}</strong> logra el primer lugar con el <strong>${porcentaje}%</strong> de los votos en Diputados.`;
                  } else if (index === 1) {
                    return `Le sigue <strong>${nombre}</strong> (${porcentaje}%)`;
                  } else if (index === 2) {
                    return `y <strong>${nombre}</strong> (${porcentaje}%)`;
                  }
                  return null;
                })
                .filter(Boolean)
                .join(" ");

              return `<p>A nivel nacional, ${blocksList}.</p>`;
            }

            // Fallback a la lógica original con ganadores
            return `<p>A nivel nacional, <strong>${primero?.name}</strong> logra el primer lugar con el <strong>${primero?.votes_percent?.toFixed(2)}%</strong> de los votos en Diputados. Le siguen <strong>${segundo?.name}</strong> (${segundo?.votes_percent?.toFixed(2)}%) y <strong>${tercero?.name}</strong> (${tercero?.votes_percent?.toFixed(2)}%).</p>`;
          })(),
        },
        {
          type: "text",
          value: `<p>Más de 35 millones de personas figuraban en el padrón electoral.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/elecciones-2025-asumen-nuevos-diputados-senadores_0_efms57JpK0.html" target="_blank" rel="noopener noreferrer">Cuándo asumen los nuevos diputados</a></h2>`
        },
        {
          type: "text",
          value: `<p>Los legisladores electos asumirán sus funciones el 10 de diciembre. De acuerdo con el cronograma electoral, la fecha es la misma tanto para los cargos nacionales como para los cargos locales.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/elecciones-2025-vota-domingo-26-octubre_0_LJ8ckau2n1.html" target="_blank" rel="noopener noreferrer">Cuántos diputados y senadores se renuevan en estas Elecciones 2025</a></h2>`
        },
        {
          type: "text",
          value: `<p>En esta elección se renueva la mitad de la Cámara de Diputados, es decir 127 bancas, distribuidas entre todas las provincias en proporción a su población. También se elige un tercio del Senado (24 bancas), que este año corresponde a la Ciudad Autónoma de Buenos Aires, Chaco, Entre Ríos, Neuquén, Río Negro, Salta, Santiago del Estero y Tierra del Fuego.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/pasa-voto-elecciones-2025-argentina_0_AKXPNSybCF.html" target="_blank" rel="noopener noreferrer">Qué pasa si no voté en estas elecciones en ${localidad}</a></h2>`
        },
        {
          type: "text",
          value: `<p>En estas elecciones legislativas del 26 de octubre, el voto es obligatorio para todos los ciudadanos argentinos de entre 18 y 70 años. Tanto para los habitantes de ${localidad} como del resto del país, no presentarse sin justificación puede traer multas económicas y restricciones administrativas.</p>`
        },
        {
          type: "text",
          value: `<p>Quienes no concurrieron deberán presentar una justificación válida dentro de los 60 días posteriores al comicio. Además, deberán afrontar una multa cuyo valor varía entre $1.000 y $2.000, dependiendo de la cantidad de veces que se haya omitido votar en elecciones anteriores.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/pasa-voto-elecciones-2025-multas-justificacion-documentos_0_drGEE6u5b8.html" target="_blank" rel="noopener noreferrer">Cómo justificar el no voto en ${localidad}</a></h2>`
        },
        {
          type: "text",
          value: `<p>Quienes no votaron y tienen una excepción legal pueden justificar el no voto online. El trámite se hace en la web de la Cámara Nacional Electoral y permite evitar multas y sanciones.</p>`
        },
        {
          type: "text",
          value: `<p>Para comenzar, hay que escribir el número de DNI, género, distrito de votación y código de validación. El sistema indica automáticamente si el votante figura como infractor y da la opción de justificar o pagar la multa.</p>`
        },
        {
          type: "text",
          value: `<p>En caso de justificar, se debe adjuntar un documento que acredite el motivo: certificado médico, constancia policial, pasajes de viaje o cualquier comprobante que respalde la inasistencia. La documentación será evaluada por la Secretaría Electoral correspondiente.</p>`
        },
        {
          type: "text",
          value: `<p>Si la justificación es aceptada, el votante es dado de baja del Registro de Infractores. Si es rechazada, se deberá abonar la multa establecida por el Código Electoral, que va de los $1000 a los $2000, según la cantidad de multas acumuladas.</p>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  getSections() {
    return [
      {
        _id: 15006,
        name: "Información General",
        url: "informacion-general",
        nsSite: "",
        autoplay: false,
        metadata: {}
      }
    ];
  }

  getMetadata() {
    return {
      typeWeb: "small",
      origin: "default",
      payWallAccessControl: "freemium",
      sponsored: false,
      accessProduct: "CLARIN_D",
      canHaveAmp: true,
      canHaveComments: true,
      autoRefresh: true,
      titleEnable: false,
      footer_visible: true,
      ualterDisabled: false,
      trinityDisabled: false,
      disabledTimelineLiveblog: false,
      featuredContent: false,
      stopWords: true
    };
  }

  getTags(params) {
    return [
      { name: "Elecciones 2025", slug: "elecciones-2025", subject: "subject" }
    ];
  }

  generateMeta(content, data, params) {
    const title = content?.title || `Elecciones Diputados 2025`;
    const description = this.extractDescription(content) ||
      `Resultados elecciones diputados nacionales 2025`;
    const imageUrl = this.getImage(params.codeLetter);
    const urlNew = buildElectionUrl(params);

    return {
      description,
      title,
      keywords: `Diputados, Elecciones 2025, Legislativas, Resultados, Congreso`,
      url: urlNew,
      urlImage: imageUrl,
      extra: [
        { name: "title", content: title },
        { name: "description", content: description },
        { name: "distribution", content: "global" },
        { name: "robots", content: "max-image-preview:large" },
        { property: "og:image", content: imageUrl },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "article:published_time", content: "2025-10-26T14:00:00-03:00" },
        { property: "article:modified_time", content: data.last_update }
      ]
    };
  }

  extractDescription(content) {
    return content?.description ||
      content?.body?.[0]?.value?.replace(/<[^>]*>/g, '')?.trim();
  }
}